import { i18n } from 'i18next';

export const LanguageAutoSelection = (i18n: i18n): void => {
    const params = new URLSearchParams(window.location.search);
    /**
     * It will set language if there is a language param
     * in query parameters
     */
    if (params.has('language')) {
        const activeLanguage = params.get('language') ?? undefined;
        i18n.changeLanguage(activeLanguage);
    }
};
